import { render, staticRenderFns } from "./RequestsForMaterial.vue?vue&type=template&id=6ad77527"
import script from "./RequestsForMaterial.vue?vue&type=script&lang=js"
export * from "./RequestsForMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports